import { render, staticRenderFns } from "./corp-auth.vue?vue&type=template&id=397f72cf&scoped=true&"
import script from "./corp-auth.vue?vue&type=script&lang=js&"
export * from "./corp-auth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397f72cf",
  null
  
)

export default component.exports